<!--
 * @Author: your name
 * @Date: 2022-03-12 14:30:05
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-13 01:53:12
 * @Description: file content
-->
<template functional>
  <div class="info-container">
    <slot name="title"></slot>
    <slot name="content"></slot>
  </div>
</template>

<script>
  export default {};
</script>

<style lang="less" scoped>
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .flex-column {
    flex-direction: column;
  }
  .info-container {
    .center();
    .flex-column();
    width: 100%;
    margin-top: 20px;
  }
</style>
